import script from "./Policies.vue?vue&type=script&setup=true&lang=js"
export * from "./Policies.vue?vue&type=script&setup=true&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=6bd2d31c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd2d31c"]])

export default __exports__